import React, { useState } from "react";
import { Navbar, Container, Nav } from "react-bootstrap";


export default function Navigation() {
  const [navbar, setNavbar] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const changeBackground = () => {
    if (window.scrollY >= 10) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  window.addEventListener("scroll", changeBackground);

  return (
    <Navbar
      bg={navbar ? "white" : "transparent"}
      expand="sm"
      fixed="top"
      className="navbar"
      expanded={expanded}
    >
      <Container>
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          onClick={() => {
            setNavbar(false);
            setExpanded(expanded ? false : "expanded");
          }}
          placement="start"
        />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav>
            <Nav.Link
              id="navbar-link"
              href="#home"
              onClick={() => setExpanded(false)}
            >
              Home
            </Nav.Link>
            <Nav.Link
              id="navbar-link"
              href="#about"
              onClick={() => setExpanded(false)}
            >
              About
            </Nav.Link>
            <Nav.Link
              id="navbar-link"
              href="#portfolio"
              onClick={() => setExpanded(false)}
            >
              Projects
            </Nav.Link>
            <Nav.Link
              id="navbar-link"
              href="#contact"
              onClick={() => setExpanded(false)}
            >
              Contact
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
      
    </Navbar>
  );
}
